import { twCustomConfig } from "./tw-config"

const {
  theme: {
    colors: {
      black: { name: defaultBackgroundColor },
      grey: { name: defaultSecondaryAccentColor },
      berry: { name: defaultAccentColor },
    },
  },
} = twCustomConfig

const colorNameMapper = {
  grey: { n: "grey", s: 800 },
  lightgrey: { n: "grey", s: 600 },
  berry: { n: "berry", s: "DEFAULT" },
  white: { n: "white", s: "DEFAULT" },
  black: { n: "black", s: "DEFAULT" },
}

const colorCombinations = (data = {}) => {
  return {
    accent: data.theme_colors_combinations?.value || defaultAccentColor,
    background: data.background_color?.value || defaultBackgroundColor,
  }
}

export const getColors = (data) => {
  const accentColor =
    typeof data === "string"
      ? data
      : data?.theme_colors_combinations?.value || defaultAccentColor

  const secondaryAccentColor =
    data?.secondary_theme_colors_combinations?.value ||
    defaultSecondaryAccentColor

  const backgroundColor =
    data?.background_color?.value || defaultBackgroundColor

  const accentName = colorNameMapper[accentColor].n
  const accentStrength = colorNameMapper[accentColor].s

  const secAccentName = colorNameMapper[secondaryAccentColor].n
  const secAccentStrength = colorNameMapper[secondaryAccentColor].s

  const backgroundName = colorNameMapper[backgroundColor].n
  const backgroundStrength = colorNameMapper[backgroundColor].s

  return [
    {
      name: backgroundColor,
      value: twCustomConfig.theme.colors[backgroundName][backgroundStrength],
      isAsPage: data?.same_background_as_page,
    },
    {
      name: accentColor,
      value: twCustomConfig.theme.colors[accentName][accentStrength],
    },
    {
      name: secondaryAccentColor,
      value: twCustomConfig.theme.colors[secAccentName][secAccentStrength],
    },
  ]
}

export const defaultColors = getColors()

export default colorCombinations
